import axios from 'axios'

class CredenciamentoApiClient {

    async buscarDadosGeraisCredenciamento(licitacaoId){
        return axios.get(`/licitacao/api/public/v1/credenciamentos/${licitacaoId}`)
    }

    async baixarDocumentacaoFornecedorPublica(licitacaoId, fornecedorId){
        return axios.get(`/licitacao/api/public/v1/credenciamentos/${licitacaoId}/solicitacoes/fornecedores/${fornecedorId}`,
            { responseType: 'arraybuffer' })
    }

    async buscarAnexosEditalCredenciamento(licitacaoId){
        return axios.get(`/licitacao/api/public/v1/credenciamentos/${licitacaoId}/anexos`)
    }

    async buscarEsclarecimentosImpugnacoesCredenciamento(licitacaoId){
        return axios.get(`/licitacao/api/public/v1/credenciamentos/${licitacaoId}/esclarecimentosImpugnacoes`)
    }

    async solicitarEsclarecimentoImpugnacaoCredenciamentoApi(payload) {
        const formData = new FormData()
        if (payload.anexo) {
            formData.append('anexo', payload.anexo)
        }
        payload.anexo = null
        formData.append('input', new Blob([JSON.stringify(payload)], {type: 'application/json'}))
        return axios.post(`/licitacao/api/public/v1/credenciamentos/${payload.licitacaoId}/esclarecimentoImpugnacao`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    async buscarResultadoCredenciamentoPublico(licitacaoId, { page = 1, size = 100 } = {}) {
        return axios.get(`/licitacao/api/public/v1/credenciamentos/${licitacaoId}/resultado`, {
            params: { page, size }
        })
    }

    async buscarItensLotesCredenciamento(licitacaoId){
        return axios.get(`/licitacao/api/public/v1/credenciamentos/${licitacaoId}/itensLotes`)
    }
}

export default new CredenciamentoApiClient()
